import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";


function AddTeamFeedback({ onClose, user_id, year, onSuccess, enb_user = 0}) {
const { register, handleSubmit, reset, setValue, formState:{ errors } } = useForm();
const { setGlobalLoading, token } = useOutletContext();
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const [selfReview, setSelfReview] = useState(null);
const [selfRatings, setSelfRatings] = useState({});

  useEffect(() => {
    setValue("user_id", user_id);
  }, [user_id]);

  useEffect(() => {
    setValue("enb_user", enb_user);
  }, [enb_user]);
  const [parameters, setParameters] = useState([]);
  const [data, setData] = useState([]);
  const [kraScores, setKraScores] = useState([]);
  const [autoRating, setAutoRating] = useState(null);

  useEffect(() => {
    fetchPerformers();
  }, [user_id, year]);

 const fetchPerformers = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/performance/performers`,
          {
            params: { user_id: user_id, year: year },
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const d = response.data;
        const team = d.team || [];
        const enb_team = d.enb_team || [];
        if(enb_user === 1){
          setData(enb_team);
        }else{
          setData(team);
        }
      } catch (err) {
        console.error(err);
      }
    };
  const handleEmployeeChange = async (e) => {
    
    const selectedUserId = e.target.value;
    const selectedEmployee = data.find((emp) => String(emp.id) === String(selectedUserId));
    const fallbackDesignation = e.target.options[e.target.selectedIndex].getAttribute("data-designation");
    const desId = parseInt(selectedEmployee?.designation_id || fallbackDesignation, 10);
    reset();
    setValue("employee_id", selectedUserId);

    const kraData = await fetchKRAbyDesignation(desId); // ✅ get fresh data
    await fetchExistingFeedback(selectedUserId);
    await fetchKRAScores(selectedUserId, kraData); // ✅ pass it
  };
  
  const fetchKRAbyDesignation = async (designation_id) => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_BASE_URL}/performance/kra_by_designation`,
        {
          params: {
            designation_id,
            year: year,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const kraData = res.data.parameters || [];

    setParameters(kraData);
    return kraData;
    } catch (err) {
      console.error(err);
    }
  };

  const fetchExistingFeedback = async (employeeId) => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_BASE_URL}/performance/get_feedback`,
        {
          params: {
            employee_id: employeeId,
            year: year,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const { review, ratings, selfreview, selfratings } = res.data;

      setSelfReview(selfreview);
      setSelfRatings(selfratings || {});

      // ❌ No existing data → reset form
      if (!review) {
        setValue("overall_comments", "");
        return;
      }

      // ✅ Set overall comments
      setValue("overall_comments", review.overall_comments);

      // ✅ Set ratings dynamically
      Object.entries(ratings).forEach(([paramId, r]) => {
        setValue(`ratings.${paramId}.rating`, r.rating);
        setValue(`ratings.${paramId}.comments`, r.comments);
      });

    } catch (err) {
      console.error("Error fetching feedback:", err);
    }
  };

  const fetchKRAScores = async (employeeId, kraData) => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_BASE_URL}/performance/kra_scores`,
        {
          params: { user_id: employeeId, year },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const scores = res.data.kra_scores || [];
      setKraScores(scores);
      calculateAutoRating(scores, kraData);
    } catch (err) {
      console.error(err);
    }
  };

  const calculateAutoRating = (scores, params) => {
    if (!scores.length) return;

    const contributionItem = scores.find(
      (item) => item.name === "Contribution"
    );

    const contribution = contributionItem?.percentage || 0;

    let rating = 1;
    if (contribution >= 80) rating = 5;
    else if (contribution >= 60) rating = 4;
    else if (contribution >= 40) rating = 3;
    else if (contribution >= 20) rating = 2;

    setAutoRating({
      value: rating,
      avg: contribution,
    });

    const ownershipKRA = params.find(
      (p) => p.name === "Ownership of Search Value Chain"
    );

    if (ownershipKRA) {
      setValue(`ratings.${ownershipKRA.id}.rating`, rating);
    }
  };

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);

      const cleanedRatings = Object.fromEntries(
      Object.entries(data.ratings || {}).filter(([_, v]) => v && v.rating)
    );

    data.ratings = cleanedRatings;

    await axios.post(
        `${REACT_APP_API_BASE_URL}/performance/add_new_feedback`,
        data, // ✅ send JSON directly
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toastr.success("Feedback submitted successfully!");
      onSuccess?.();
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      toastr.error("Error submitting feedback");
    } finally {
      setGlobalLoading(false);
    }
  };

return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Final Year Feedback</h4>
                <input type="hidden" {...register("user_id")} />
              <button onClick={() => onClose()} type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left"}}>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="mb-2">
                        <label className="form-label">Performer *</label>
                        <input type="hidden" name="reviewed_by" {...register("reviewed_by")} value={user_id} />
                        <input type="hidden" name="year" {...register("year")} value={year} />
                        <select
                          className={`form-select ${
                            errors.roletype_id ? "is-invalid" : ""
                          }`}
                          {...register("employee_id", {
                            required: true,
                            onChange: (e) => handleEmployeeChange(e),
                          })}
                        >
                          <option value="">Select Employee</option>
                          {data?.map((item) => (
                            <option key={item.id} value={item.id} data-designation={item.designation_id}>
                              {item.has_review ? "✅ " : "⏳ "}
                              {item.employee_name} - {item.designation}
                            </option>
                          ))}
                        </select>
                        </div>

                      {kraScores.length > 0 && enb_user === 0 && (
                        <div className="mb-3 border rounded p-3 bg-light">

                          <div className="d-flex justify-content-between align-items-center">
                            <h6>Ownership of Search Value Chain</h6>
                            <span className="badge bg-secondary">Auto-calculated</span>
                          </div>

                          {Array.isArray(parameters) && parameters.length > 0 &&
                          parameters
                          .filter(param => param.name === "Ownership of Search Value Chain")
                          .map((param) => {
                            const points = param.description
                              ? param.description.split("|").map((p) => p.trim())
                              : [];

                            return (
                              <div key={param.id} className="mb-3 border rounded p-3">

                                {/* 🔵 Self Rating Display */}
                                {selfRatings?.[param.id] && (
                                  <div className="mb-2 p-2 bg-light border rounded">
                                    <div className="d-flex">
                                      <small className="text-muted me-1">Self Rating:-</small>
                                      <strong>{selfRatings[param.id].rating}</strong>
                                    </div>

                                    {selfRatings[param.id].comments && (
                                      <p className="mb-0 fs-12 text-muted">
                                        {selfRatings[param.id].comments}
                                      </p>
                                    )}
                                  </div>
                                )}

                               </div>
                            );
                          })
                        }

                          <p className="text-muted fs-12">
                            This rating is auto-calculated based on contribution score.
                          </p>

                          {/* 🔥 KRA breakdown */}
                          <div className="row">
                            {kraScores
                              .filter(item => item.name !== "Contribution")
                              .map((item, index) => (
                                <div key={index} className="col-6 d-flex justify-content-between">
                                  <span>{item.name}</span>
                                  <strong>{item.percentage}%</strong>
                                </div>
                            ))}
                          </div>

                          {/* 🔥 Auto Rating display */}
                          {autoRating && (
                            <div className="mt-3">
                              <strong>Auto Rating: </strong>
                              <span className="badge bg-success">
                                {autoRating.value}
                              </span>
                            </div>
                          )}
                          

                          {/* 🔥 Rating Dropdown (DISABLED) */}
                          {(() => {
                            const ownershipKRA = parameters.find(
                              p => p.name === "Ownership of Search Value Chain"
                            );

                            if (!ownershipKRA) return null;

                            return (
                              <>
                                <label className="fs-12 form-label mt-3">Rating (1-5)</label>
                                <select
                                  className="form-select mb-2"
                                  disabled
                                  {...register(`ratings.${ownershipKRA.id}.rating`, { required: true })}
                                >
                                  <option value="">Rate</option>
                                  {[1, 2, 3, 4, 5].map((r) => (
                                    <option key={r} value={r}>{r}</option>
                                  ))}
                                </select>

                                {/* 🔥 Comments */}
                                <label className="fs-12 form-label">Comments</label>
                                <textarea
                                  className="form-control mb-2"
                                  placeholder="Comments on Ownership of Search Value Chain"
                                  {...register(`ratings.${ownershipKRA.id}.comments`)}
                                />
                              </>
                            );
                          })()}

                        </div>
                      )}

                       {Array.isArray(parameters) && parameters.length > 0 &&
                          parameters
                          .filter(param => param.name !== "Ownership of Search Value Chain")
                          .map((param) => {
                            const points = param.description
                              ? param.description.split("|").map((p) => p.trim())
                              : [];

                            return (
                              <div key={param.id} className="mb-3 border rounded p-3">

                                {/* Title */}
                                <h6>{param.name}</h6>

                                {/* Description as BULLETS */}
                                {points.length > 0 && (
                                  <ul
                                    className="text-muted mb-2 ps-3"
                                    style={{ listStyleType: "disc", paddingLeft: "20px" }}
                                  >
                                    {points.map((point, index) => (
                                      <li key={index}
                                          dangerouslySetInnerHTML={{ __html: point }}
                                        ></li>
                                    ))}
                                  </ul>
                                )}

                                {/* 🔵 Self Rating Display */}
                                {selfRatings?.[param.id] && (
                                  <div className="mb-2 p-2 bg-light border rounded">
                                    <div className="d-flex">
                                      <small className="text-muted me-1">Self Rating:-</small>
                                      <strong>{selfRatings[param.id].rating}</strong>
                                    </div>

                                    {selfRatings[param.id].comments
                                      ?.split("\n")
                                      .map((line, index) => (
                                        <p key={index} className="mb-0 fs-12 text-muted">
                                          {line}
                                        </p>
                                    ))}
                                  </div>
                                )}

                                {/* Rating */}
                                <label className="fs-12 form-label">Rating (1-5)</label>
                                <select
                                  className="form-select mb-2"
                                  disabled={param.name === "Ownership of Search Value Chain"}
                                  {...register(`ratings.${param.id}.rating`, { required: true })}
                                >
                                  <option value="">Rate</option>
                                  {[1, 2, 3, 4, 5].map((r) => (
                                    <option key={r} value={r}>{r}</option>
                                  ))}
                                </select>

                                {/* Comments */}
                                <label className="fs-12 form-label">Comments</label>
                                <textarea
                                  className="form-control mb-2"
                                  placeholder={`Comments on ${param.name}`}
                                  {...register(`ratings.${param.id}.comments`)}
                                />

                              </div>
                            );
                          })
                        }
                        {/* 🔵 Self Overall Comments */}
                          {selfReview?.overall_comments && (
                            <div className="mb-2 p-2 bg-light border rounded">
                              <label className="form-label fs-12 text-muted">
                                Self Overall Comments
                              </label>
                              {selfReview?.overall_comments
                                ?.split("\n")
                                .map((line, index) => (
                                  <p key={index} className="mb-0 fs-12 text-muted">
                                    {line}
                                  </p>
                              ))}
                            </div>
                          )}
                        {Array.isArray(parameters) && parameters.length > 0 && (
                          <div className="mb-2">
                            <label className="form-label">Overall Comments *</label>
                            <input
                              type="text"
                              {...register("overall_comments")}
                              className={`form-control ${errors.address && "is-invalid"}`}
                            />
                          </div>
                        )}
                        
                    </div>
                </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>  
);    
}
export default AddTeamFeedback;